@use '../../style/globals.scss' as *;

.LocalePickerPanel {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    background: #111111;

    .flagsContainer {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        justify-content: center;
        padding: 7px;
        max-height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        @include scrollbar-styles;
    }

    .flagButton {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;
        // width: 160px;
        height: 36px;
        padding: 0 12px 0 6px;
        border: 2px solid transparent;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 20px;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
            border-color: rgba(255, 255, 255, 0.4);
            transform: scale(1.05);
        }

        &.isSelected {
            border-color: rgba(255, 255, 255, 0.8);
            box-shadow: 0 0 8px rgba(255, 255, 255, 0.3);
        }
    }

    .flag {
        width: 26px !important;
        height: 26px !important;
        border-radius: 50%;
        flex-shrink: 0;
    }

    .flagLabel {
        flex: 1;
        text-align: center;
        color: rgba(255, 255, 255, 0.85);
        font-size: 11px;
        font-weight: 500;

        &::first-letter {
            text-transform: uppercase;
        }
    }
}
